// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"01da9b4e","311":"cc652de0","583":"867a661e","725":"56c5e963","845":"8ea892ac","983":"1b926913"}[chunkId] + ".chunk.js";
};